import React, { useState } from 'react';

import { Button, Typography } from '@mui/material';

import { track } from '@hbf/analytics';

import { AnalyticsEvent } from '@kamernet/core/Analytics/types';
import { useIntl } from '@kamernet/core/Intl';
import { Locale } from '@kamernet/core/Intl/types';
import { CommonStyles } from '@kamernet/styles/CommonStyles';

import { ListingDetailsContext } from '../../ListingDetailsContext';

import styles from './About.module.css';

export const About = () => {
  const { listingDetails } = ListingDetailsContext.useContext();

  const { T, locale } = useIntl();

  const [isExpanded, setIsExpanded] = useState(false);
  const [showReadMoreButton, setShowReadMoreButton] = useState(false);

  const descriptionRef = React.useRef<HTMLElement>(null);

  const listingDescription =
    locale === Locale.en
      ? listingDetails.englishDescription
      : listingDetails.dutchDescription;

  React.useEffect(() => {
    if (descriptionRef.current) {
      const lineHeight = parseInt(
        window.getComputedStyle(descriptionRef.current).lineHeight,
        10,
      );
      const { scrollHeight } = descriptionRef.current;
      const numberOfLines = Math.ceil(scrollHeight / lineHeight);
      const isTextLong = numberOfLines > 4;
      setShowReadMoreButton(isTextLong);
    }
  }, [listingDescription]);

  const handleReadMoreClick = React.useCallback(() => {
    setIsExpanded(!isExpanded);
    track(AnalyticsEvent.ClickedShowMoreLDP);
  }, [isExpanded]);

  return (
    <section className={styles.root}>
      <Typography className={CommonStyles.margin_bottom_2} variant="h5">
        {T('ldp.about_the_place')}
      </Typography>
      <pre className={styles.preText}>
        <Typography
          ref={descriptionRef}
          className={`${CommonStyles.margin_bottom_1} ${
            !isExpanded ? styles.collapsedText : ''
          }`}
          variant="body2"
        >
          {listingDescription}
        </Typography>
      </pre>

      {showReadMoreButton && (
        <Button variant="outlined" onClick={handleReadMoreClick}>
          {isExpanded ? T('LBL_SHOW_LESS') : T('LBL_SHOW_MORE')}
        </Button>
      )}
    </section>
  );
};
